var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23C5.15871 23 0 17.8413 0 11.5C0 5.15871 5.15871 0 11.5 0C17.8413 0 23 5.15871 23 11.5C23 17.8413 17.8413 23 11.5 23ZM11.5 0.958333C5.68771 0.958333 0.958333 5.68771 0.958333 11.5C0.958333 17.3123 5.68771 22.0417 11.5 22.0417C17.3123 22.0417 22.0417 17.3123 22.0417 11.5C22.0417 5.68771 17.3123 0.958333 11.5 0.958333ZM14.2677 18.2083C10.1056 18.2083 4.79167 12.8953 4.79167 8.73233C4.79167 7.82671 5.13475 6.98433 5.75767 6.36237L7.52771 4.59329L11.0208 8.08642L9.06679 10.0414C9.88425 11.8987 11.1608 13.178 12.9567 13.939L14.9145 11.9811L18.4086 15.4742L16.6395 17.2433C16.0176 17.8662 15.1762 18.2093 14.2686 18.2093L14.2677 18.2083ZM7.52675 5.94837L6.43425 7.03992C5.99246 7.48171 5.74904 8.08258 5.74904 8.73233C5.74904 12.3941 10.604 17.25 14.2667 17.25C14.9174 17.25 15.5183 17.0066 15.9601 16.5648L17.0516 15.4732L14.9136 13.3352L13.1895 15.0592L12.8992 14.949C10.626 14.0808 8.99683 12.4526 8.05479 10.1085L7.93692 9.81429L9.66479 8.08642L7.52771 5.94837H7.52675Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.651044f58f72cb49ca6b6ad3a7ed62ff.svg";
export { ForwardRef as ReactComponent };